<template>
   <div class="header">
       <div class="header-title-btn">&lt;</div>
     <div class="header-title">我是头部</div>
   </div>
</template>

<script>
export default {
  name: 'header',
  props: {

  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    goBack () {

    }

  }
}
</script>
<style lang="less" scoped>

  .header{
    height: 50px;
    display: flex;
    position: relative;
    align-items: center;
    box-shadow: 0 0 3px rgba(0,0,0,.2);
    justify-content: center;
    background-color: #fff;
    border-bottom: 0;

    .header-title{
      font-size: 14px;
    }

    .header-title-btn{
       position: absolute;
       left: 0;
       top:0;
        height: 50px;
      width: 50px;
      line-height: 50px;
      text-align: center;
    }
  }
</style>
